import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "section" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title has-text-centered" }, " LinkBoost "),
    /*#__PURE__*/_createElementVNode("p", { class: "subtitle has-text-centered" }, [
      /*#__PURE__*/_createTextVNode(" Automated "),
      /*#__PURE__*/_createElementVNode("strong", null, "tbd"),
      /*#__PURE__*/_createTextVNode("! ")
    ])
  ])
], -1)

import RuntimePopover from '@/components/RuntimePopover.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RuntimePopover),
    _hoisted_1,
    _createVNode(_component_router_view),
    _createElementVNode("nav", null, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Startup")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "/home" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "/browser/install" }, {
        default: _withCtx(() => [
          _createTextVNode("/browser/install")
        ]),
        _: 1
      }),
      _createTextVNode(" | "),
      _createVNode(_component_router_link, { to: "/browser/choice" }, {
        default: _withCtx(() => [
          _createTextVNode("/browser/choice")
        ]),
        _: 1
      }),
      _createTextVNode(" | ")
    ])
  ], 64))
}
}

})